import { render, staticRenderFns } from "./vessel.vue?vue&type=template&id=f22cd9b6&scoped=true"
import script from "./vessel.vue?vue&type=script&lang=js"
export * from "./vessel.vue?vue&type=script&lang=js"
import style0 from "./vessel.vue?vue&type=style&index=0&id=f22cd9b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f22cd9b6",
  null
  
)

export default component.exports